// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5d97a441","774":"90d443a4"}[chunkId] + ".chunk.js";
};